import en from './en';
import ja from './ja';

const messages = {
    en,
    ja
}

export default messages;